"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationMetadataSchema = exports.OrderDirectionEnum = void 0;
const zod_1 = require("zod");
var OrderDirectionEnum;
(function (OrderDirectionEnum) {
    OrderDirectionEnum["ASC"] = "ASC";
    OrderDirectionEnum["DESC"] = "DESC";
})(OrderDirectionEnum || (exports.OrderDirectionEnum = OrderDirectionEnum = {}));
exports.PaginationMetadataSchema = zod_1.z.object({
    offset: zod_1.z.number({ required_error: 'offset is required' }),
    limit: zod_1.z.number({ required_error: 'limit is required' }),
    orderBy: zod_1.z.string({ required_error: 'orderBy is required' }),
    orderDirection: zod_1.z.nativeEnum(OrderDirectionEnum),
    numElements: zod_1.z.number({ required_error: 'numElements is required' }).optional().nullable(),
});
